var map = {
	"./The Little Things - A Edwards Huntington.pdf": 5193,
	"./cartagena-teaser-20200820.pdf": 7152,
	"./hello-world-20190912.pdf": 8172,
	"./just-super-20210703.fdx": 4455,
	"./just-super-20210703.pdf": 2031,
	"./just-super-character-perspective-20210703.pdf": 5229,
	"./just-super-summary-20210703.pdf": 1875
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7292;